<div class="checklist-item">
	<div class="icon-container" [class.warning]="item.warning" [class.error]="item.error" [title]="item.notification ? item.notification : ''">
		<i *ngIf="item.warning || item.error" class="fa fa-{{item.warning ? 'warning' : 'exclamation-circle'}}"></i>
		<img *ngIf="!item.checked && !(item.warning || item.error)" src="/resources/img/check-hollow.svg">
		<img *ngIf="item.checked" src="/resources/img/check-green.svg">
	</div>
	<div class="checklist-label">
		<span>{{ item.label | translate }}</span>
	</div>
</div>
